import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CodeInputModule } from 'angular-code-input';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { IconModule, ButtonModule, InputModule, } from '@pn-plus/ngx-design-system';
import { IdentityVerificationPageComponent } from './identity-verification/identity-verification.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TextMaskModule } from 'angular2-text-mask';
import { PagesRoutingModule } from './pages-routing.module';
import { RegistrationCompleteComponent } from './registration-complete/registration-complete.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { SetAvatarComponent } from './set-avatar/set-avatar.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SetPhoneComponent } from './set-phone/set-phone.component';
import { SetPinComponent } from './set-pin/set-pin.component';
import { VerifyRecoveryPhoneComponent } from './verify-recovery-phone/verify-recovery-phone.component';
import { VerifyTwofactorPhoneComponent } from './verify-twofactor-phone/verify-twofactor-phone.component';
import { PnUiModule } from '@nrwl/pn-ui';
import { LoginFormComponent } from './login-form/login-form.component';
import { InvitationComponent } from './invitation/invitation.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InvitationExpiredComponent } from './invitation/invitation-expired/invitation-expired.component';
import { InvitationNotFoundComponent } from './invitation/invitation-not-found/invitation-not-found.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    declarations: [
        LoginLayoutComponent,
        SetPinComponent,
        SetPhoneComponent,
        SetAvatarComponent,
        SetPasswordComponent,
        ResetPasswordComponent,
        RegistrationCompleteComponent,
        IdentityVerificationPageComponent,
        VerifyRecoveryPhoneComponent,
        VerifyTwofactorPhoneComponent,
        LoginFormComponent,
        InvitationComponent,
        InvitationExpiredComponent,
        InvitationNotFoundComponent,
    ],
    imports: [
        FormsModule,
        IconModule,
        MatIconModule,
        ReactiveFormsModule,
        CodeInputModule,
        CoreModule,
        CommonModule,
        RouterModule,
        MatSliderModule,
        MatDialogModule,
        NgxSpinnerModule,
        PagesRoutingModule,
        MatProgressSpinnerModule,
        PnUiModule,
        TextMaskModule,
        MatSlideToggleModule,
        ButtonModule,
        InputModule,
    ],
    exports: [TextMaskModule, VerifyTwofactorPhoneComponent],
    providers: [],
})
export class PagesModule {}
